module.exports = __webpack_public_path__ + "img/edge_activites_rando_journee.4427a07b.svg";